import React from "react"

export const TangramEmptyStateProject = () => (
  <svg
    width="62"
    height="123"
    viewBox="0 0 62 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.9219 106.551L44.8183 105.447L45.5255 104.74L45.9219 105.136L46.3183 104.74L47.0254 105.447L45.9219 106.551ZM42.5255 101.74L44.0255 103.24L43.3183 103.947L41.8184 102.447L42.5255 101.74ZM39.5255 98.7399L41.0255 100.24L40.3184 100.947L38.8184 99.447L39.5255 98.7399ZM36.5255 95.7399L38.0255 97.2399L37.3184 97.947L35.8184 96.447L36.5255 95.7399ZM33.5255 92.7399L35.0255 94.2399L34.3184 94.947L32.8184 93.447L33.5255 92.7399ZM31.2755 90.4899L32.0255 91.2399L31.3184 91.947L30.5684 91.197L31.2755 90.4899ZM47.8183 103.24L49.3183 101.74L50.0254 102.447L48.5254 103.947L47.8183 103.24ZM50.8183 100.24L52.3183 98.7399L53.0254 99.447L51.5254 100.947L50.8183 100.24ZM53.8183 97.2399L55.3183 95.7399L56.0254 96.447L54.5254 97.947L53.8183 97.2399ZM56.8183 94.2399L58.3183 92.7399L59.0254 93.447L57.5254 94.947L56.8183 94.2399ZM60.2148 90.8435L59.8183 91.2399L60.5254 91.947L61.629 90.8435L60.5254 89.7399L59.8183 90.447L60.2148 90.8435ZM58.3183 88.947L56.8183 87.447L57.5254 86.7399L59.0254 88.2399L58.3183 88.947ZM55.3183 85.947L53.8183 84.447L54.5254 83.7399L56.0254 85.2399L55.3183 85.947ZM52.3183 82.9471L50.8183 81.4471L51.5254 80.7399L53.0254 82.2399L52.3183 82.9471ZM49.3183 79.9471L47.8183 78.4471L48.5254 77.74L50.0254 79.24L49.3183 79.9471ZM46.3183 76.9471L45.5683 76.1971L46.2754 75.49L47.0254 76.24L46.3183 76.9471Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.2914 92.7122L56.7914 94.2122L57.4985 94.9193L58.9985 93.4193L58.2914 92.7122ZM61.395 96.1728L61.395 94.03L60.395 94.03L60.395 96.1728L61.395 96.1728ZM55.2914 95.7121L53.7914 97.2121L54.4986 97.9193L55.9986 96.4193L55.2914 95.7121ZM61.395 100.459L61.395 98.3157L60.395 98.3157L60.395 100.459L61.395 100.459ZM52.2915 98.7121L50.7915 100.212L51.4986 100.919L52.9986 99.4192L52.2915 98.7121ZM49.2915 101.712L47.7915 103.212L48.4986 103.919L49.9986 102.419L49.2915 101.712ZM61.395 104.744L61.395 102.601L60.395 102.601L60.395 104.744L61.395 104.744ZM61.395 109.03L61.395 106.887L60.395 106.887L60.395 109.03L61.395 109.03ZM47.7915 108.419L49.2915 109.919L49.9986 109.212L48.4986 107.712L47.7915 108.419ZM50.7915 111.419L52.2915 112.919L52.9986 112.212L51.4986 110.712L50.7915 111.419ZM61.395 113.316L61.395 111.173L60.395 111.173L60.395 113.316L61.395 113.316ZM53.7914 114.419L55.2914 115.919L55.9986 115.212L54.4986 113.712L53.7914 114.419ZM61.395 117.601L61.395 115.459L60.395 115.459L60.395 117.601L61.395 117.601ZM56.7914 117.419L58.2914 118.919L58.9985 118.212L57.4985 116.712L56.7914 117.419ZM59.7914 120.419L61.395 122.023L61.395 119.744L60.5307 119.744L60.4985 119.712L60.4664 119.744L60.395 119.744L60.395 119.816L59.7914 120.419Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.6431 17.656L42.2795 19.0197L42.9866 19.7268L44.3502 18.3631L43.6431 17.656ZM40.685 16.4641H42.8278V15.4641H40.685V16.4641ZM40.9159 20.3833L39.5522 21.7469L40.2593 22.454L41.623 21.0904L40.9159 20.3833ZM38.1886 23.1106L36.825 24.4742L37.5321 25.1813L38.8957 23.8177L38.1886 23.1106ZM36.3993 16.4641H38.5421V15.4641H36.3993V16.4641ZM35.4613 25.8378L34.0977 27.2014L34.8048 27.9086L36.1684 26.5449L35.4613 25.8378ZM32.1136 16.4641H34.2564V15.4641H32.1136V16.4641ZM32.7341 28.5651L31.3704 29.9287L32.0775 30.6358L33.4412 29.2722L32.7341 28.5651ZM30.0068 31.2923L28.6432 32.656L29.3503 33.3631L30.7139 31.9995L30.0068 31.2923ZM27.8279 16.4641H29.9707V15.4641H27.8279V16.4641ZM27.2795 34.0196L25.9159 35.3832L26.623 36.0903L27.9866 34.7267L27.2795 34.0196ZM23.5422 16.4641H25.685V15.4641H23.5422V16.4641ZM24.5523 36.7469L23.1886 38.1105L23.8957 38.8176L25.2594 37.454L24.5523 36.7469ZM21.825 39.4741L20.4614 40.8378L21.1685 41.5449L22.5321 40.1812L21.825 39.4741ZM19.2565 16.4641H21.3993V15.4641H19.2565V16.4641ZM19.0977 42.2014L17.7341 43.565L18.4412 44.2721L19.8048 42.9085L19.0977 42.2014ZM16.5422 45.1004L17.0776 45.6358L15.5422 47.1711V44.8926H16.5422V45.1004ZM16.5422 42.7498V40.6069H15.5422V42.7498H16.5422ZM16.5422 38.4641V36.3212H15.5422V38.4641H16.5422ZM16.5422 34.1784V32.0355H15.5422V34.1784H16.5422ZM16.5422 29.8927V27.7498L15.5422 27.7498V29.8927L16.5422 29.8927ZM16.5422 25.607V23.4641L15.5422 23.4641V25.607L16.5422 25.607ZM16.5422 21.3213V19.1784L15.5422 19.1784V21.3213L16.5422 21.3213Z"
      fill="#AFB2C6"
    />
    <path
      d="M0.57814 92.0715H1.57814V91.2072L2.18169 90.6037L1.47458 89.8966L0.57814 90.793L0.57814 92.0715Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 96.3572L1.57814 94.2144H0.57814L0.57814 96.3572H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 100.643V98.5001H0.57814L0.57814 100.643H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 104.929L1.57814 102.786H0.57814L0.57814 104.929H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 109.214L1.57814 107.072H0.57814L0.57814 109.214H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 113.5V111.357H0.57814L0.57814 113.5H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 117.786L1.57814 115.643H0.57814L0.57814 117.786H1.57814Z"
      fill="#AFB2C6"
    />
    <path
      d="M1.57814 120V119.929H1.50671L1.47458 119.896L1.44246 119.929H0.57814L0.57814 122.207L2.18169 120.604L1.57814 120Z"
      fill="#AFB2C6"
    />
    <path
      d="M3.68169 89.1037L5.18168 87.6037L4.47457 86.8966L2.97458 88.3966L3.68169 89.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M4.47458 116.896L2.97458 118.396L3.68169 119.104L5.18168 117.604L4.47458 116.896Z"
      fill="#AFB2C6"
    />
    <path
      d="M6.68168 86.1037L8.18167 84.6037L7.47457 83.8966L5.97457 85.3966L6.68168 86.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M7.47457 113.896L5.97457 115.396L6.68168 116.104L8.18167 114.604L7.47457 113.896Z"
      fill="#AFB2C6"
    />
    <path
      d="M9.68167 83.1037L11.1817 81.6037L10.4746 80.8966L8.97456 82.3966L9.68167 83.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M10.4746 110.897L8.97456 112.397L9.68167 113.104L11.1817 111.604L10.4746 110.897Z"
      fill="#AFB2C6"
    />
    <path
      d="M12.6817 80.1037L14.1817 78.6037L13.4745 77.8966L11.9746 79.3966L12.6817 80.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M13.4745 107.897L11.9746 109.397L12.6817 110.104L14.1817 108.604L13.4745 107.897Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.2851 16.5L45.6815 14.8964L45.078 15.5L45.0065 15.5714L45.0065 15.5898L45.0065 15.6357L45.0065 16.5L47.2851 16.5ZM44.1815 13.3965L42.6815 11.8965L41.9744 12.6036L43.4744 14.1036L44.1815 13.3965ZM40.7208 16.5L42.8637 16.5L42.8637 15.5L40.7208 15.5L40.7208 16.5ZM41.1815 10.3965L39.6815 8.89647L38.9744 9.60357L40.4744 11.1036L41.1815 10.3965ZM36.4351 16.5L38.578 16.5L38.578 15.5L36.4351 15.5L36.4351 16.5ZM38.1816 7.39647L36.6816 5.89648L35.9744 6.60358L37.4744 8.10358L38.1816 7.39647ZM35.1816 4.39648L33.6816 2.89648L32.9745 3.60359L34.4745 5.10359L35.1816 4.39648ZM32.1494 16.5L34.2923 16.5L34.2923 15.5L32.1494 15.5L32.1494 16.5ZM32.1816 1.39649L31.078 0.292938L29.9745 1.39649L30.6816 2.10359L31.078 1.70715L31.4745 2.1036L32.1816 1.39649ZM27.8637 16.5L30.0066 16.5L30.0066 15.5L27.8637 15.5L27.8637 16.5ZM28.4745 2.89648L26.9745 4.39648L27.6816 5.10359L29.1816 3.60359L28.4745 2.89648ZM25.4745 5.89647L23.9745 7.39647L24.6816 8.10358L26.1816 6.60358L25.4745 5.89647ZM23.578 16.5L25.7209 16.5L25.7209 15.5L23.578 15.5L23.578 16.5ZM22.4745 8.89647L20.9745 10.3965L21.6816 11.1036L23.1816 9.60357L22.4745 8.89647ZM19.2923 16.5L21.4352 16.5L21.4352 15.5L19.2923 15.5L19.2923 16.5ZM19.4745 11.8965L17.9745 13.3965L18.6816 14.1036L20.1816 12.6036L19.4745 11.8965ZM16.4745 14.8964L14.871 16.5L17.1495 16.5L17.1495 15.6357L17.1495 15.5937L17.1495 15.5714L17.0781 15.5L16.4745 14.8964Z"
      fill="#AFB2C6"
    />
    <path
      d="M16.5781 106L16.5781 105L16.5781 104.944L16.411 104.944L16.375 104.944L16.3168 104.944L15.5239 104.944L15.5239 107.151L16.5781 106Z"
      fill="#AFB2C6"
    />
    <path
      d="M18.4229 104.252L19.7865 102.889L19.0794 102.182L17.7158 103.545L18.4229 104.252Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 100.944L15.5239 102.944L16.5239 102.944L16.5239 100.944L15.5239 100.944Z"
      fill="#AFB2C6"
    />
    <path
      d="M21.1502 101.525L22.5138 100.162L21.8067 99.4545L20.4431 100.818L21.1502 101.525Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 96.9444L15.5239 98.9444L16.5239 98.9444L16.5239 96.9444L15.5239 96.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M23.8774 98.798L25.2411 97.4343L24.534 96.7272L23.1703 98.0908L23.8774 98.798Z"
      fill="#AFB2C6"
    />
    <path
      d="M26.6047 96.0707L27.9683 94.7071L27.2612 94L25.8976 95.3636L26.6047 96.0707Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 92.9444L15.5239 94.9444L16.5239 94.9444L16.5239 92.9444L15.5239 92.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M29.332 93.3434L30.6956 91.9798L29.9885 91.2727L28.6248 92.6363L29.332 93.3434Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 88.9444L15.5239 90.9444L16.5239 90.9444L16.5239 88.9444L15.5239 88.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M32.0592 90.6162L33.4229 89.2525L32.7157 88.5454L31.3521 89.9091L32.0592 90.6162Z"
      fill="#AFB2C6"
    />
    <path
      d="M34.7865 87.8889L36.1501 86.5253L35.443 85.8182L34.0794 87.1818L34.7865 87.8889Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 84.9444L15.5239 86.9444L16.5239 86.9444L16.5239 84.9444L15.5239 84.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M37.5137 85.1616L38.8774 83.798L38.1703 83.0909L36.8066 84.4545L37.5137 85.1616Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 80.9445L15.5239 82.9444L16.5239 82.9444L16.5239 80.9445L15.5239 80.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M40.241 82.4344L41.6046 81.0707L40.8975 80.3636L39.5339 81.7273L40.241 82.4344Z"
      fill="#AFB2C6"
    />
    <path
      d="M42.9683 79.7071L44.3319 78.3435L43.6248 77.6364L42.2612 79L42.9683 79.7071Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 76.9445L15.5239 78.9445L16.5239 78.9445L16.5239 76.9445L15.5239 76.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 72.9445L15.5239 74.9445L16.5239 74.9445L16.5239 72.9445L15.5239 72.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M44.3319 73.5455L42.9683 72.1818L42.2612 72.8889L43.6248 74.2526L44.3319 73.5455Z"
      fill="#AFB2C6"
    />
    <path
      d="M41.6046 70.8182L40.241 69.4546L39.5339 70.1617L40.8975 71.5253L41.6046 70.8182Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 68.9445L15.5239 70.9445L16.5239 70.9445L16.5239 68.9445L15.5239 68.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M38.8774 68.0909L37.5137 66.7273L36.8066 67.4344L38.1703 68.798L38.8774 68.0909Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 64.9445L15.5239 66.9445L16.5239 66.9445L16.5239 64.9445L15.5239 64.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M36.1501 65.3637L34.7865 64L34.0794 64.7071L35.443 66.0708L36.1501 65.3637Z"
      fill="#AFB2C6"
    />
    <path
      d="M33.4228 62.6364L32.0592 61.2728L31.3521 61.9799L32.7157 63.3435L33.4228 62.6364Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 60.9445L15.5239 62.9445L16.5239 62.9445L16.5239 60.9445L15.5239 60.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M30.6956 59.9091L29.3319 58.5455L28.6248 59.2526L29.9885 60.6162L30.6956 59.9091Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 56.9445L15.5239 58.9445L16.5239 58.9445L16.5239 56.9445L15.5239 56.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M27.9683 57.1819L26.6047 55.8182L25.8976 56.5254L27.2612 57.889L27.9683 57.1819Z"
      fill="#AFB2C6"
    />
    <path
      d="M25.2411 54.4546L23.8774 53.091L23.1703 53.7981L24.5339 55.1617L25.2411 54.4546Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 52.9446L15.5239 54.9445L16.5239 54.9445L16.5239 52.9446L15.5239 52.9446Z"
      fill="#AFB2C6"
    />
    <path
      d="M22.5138 51.7274L21.1502 50.3637L20.4431 51.0708L21.8067 52.4345L22.5138 51.7274Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.5239 48.9446L15.5239 50.9446L16.5239 50.9446L16.5239 48.9446L15.5239 48.9446Z"
      fill="#AFB2C6"
    />
    <path
      d="M19.7865 49.0001L18.4229 47.6365L17.7158 48.3436L19.0794 49.7072L19.7865 49.0001Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.6237 74.2531L42.2601 72.8894L42.9672 72.1823L44.3308 73.5459L43.6237 74.2531ZM46.5227 70.945V72.945H45.5227V70.945H46.5227ZM40.8965 71.5258L39.5328 70.1622L40.2399 69.455L41.6036 70.8187L40.8965 71.5258ZM46.5227 66.945V68.945H45.5227V66.945H46.5227ZM38.1692 68.7985L36.8056 67.4349L37.5127 66.7278L38.8763 68.0914L38.1692 68.7985ZM35.4419 66.0713L34.0783 64.7076L34.7854 64.0005L36.149 65.3642L35.4419 66.0713ZM46.5227 62.945V64.945H45.5227V62.945H46.5227ZM32.7147 63.344L31.351 61.9804L32.0581 61.2733L33.4218 62.6369L32.7147 63.344ZM46.5227 58.945V60.945H45.5227V58.945H46.5227ZM29.9874 60.6167L28.6238 59.2531L29.3309 58.546L30.6945 59.9096L29.9874 60.6167ZM27.2601 57.8895L25.8965 56.5258L26.6036 55.8187L27.9673 57.1824L27.2601 57.8895ZM46.5227 54.945V56.945H45.5227V54.945H46.5227ZM24.5329 55.1622L23.1692 53.7986L23.8764 53.0915L25.24 54.4551L24.5329 55.1622ZM46.5227 50.945V52.945H45.5227V50.945H46.5227ZM21.8056 52.4349L20.442 51.0713L21.1491 50.3642L22.5127 51.7278L21.8056 52.4349ZM19.0784 49.7077L17.7147 48.344L18.4218 47.6369L19.7855 49.0006L19.0784 49.7077ZM46.5227 46.945V48.945H45.5227V46.945H46.5227ZM46.5227 42.945V44.945H45.5227V42.945H46.5227ZM17.7147 43.546L19.0784 42.1824L19.7855 42.8895L18.4218 44.2531L17.7147 43.546ZM20.442 40.8188L21.8056 39.4551L22.5127 40.1622L21.1491 41.5259L20.442 40.8188ZM46.5227 38.9451V40.9451H45.5227V38.9451H46.5227ZM23.1693 38.0915L24.5329 36.7279L25.24 37.435L23.8764 38.7986L23.1693 38.0915ZM46.5227 34.9451V36.9451H45.5227V34.9451H46.5227ZM25.8965 35.3642L27.2601 34.0006L27.9673 34.7077L26.6036 36.0713L25.8965 35.3642ZM28.6238 32.637L29.9874 31.2733L30.6945 31.9805L29.3309 33.3441L28.6238 32.637ZM46.5227 30.9451V32.9451H45.5227V30.9451H46.5227ZM31.351 29.9097L32.7147 28.5461L33.4218 29.2532L32.0581 30.6168L31.351 29.9097ZM46.5227 26.9451V28.9451H45.5227V26.9451H46.5227ZM34.0783 27.1824L35.4419 25.8188L36.149 26.5259L34.7854 27.8896L34.0783 27.1824ZM36.8056 24.4552L38.1692 23.0916L38.8763 23.7987L37.5127 25.1623L36.8056 24.4552ZM46.5227 22.9451V24.9451H45.5227V22.9451H46.5227ZM39.5328 21.7279L40.8965 20.3643L41.6036 21.0714L40.2399 22.435L39.5328 21.7279ZM46.5227 18.9451V20.9451H45.5227V18.9451H46.5227ZM42.2601 19.0007L43.6237 17.637L44.3308 18.3441L42.9672 19.7078L42.2601 19.0007Z"
      fill="#AFB2C6"
    />
  </svg>
)
